export const GET_CITIZENS_REQUEST = 'resources/citizens/GET_CITIZENS_REQUEST'
export const GET_CITIZENS_SUCCESS = 'resources/citizens/GET_CITIZENS_SUCCESS'
export const GET_CITIZENS_ERROR = 'resources/citizens/GET_CITIZENS_ERROR'

export const UNLINK_CITIZEN_REQUEST = 'resources/UNLINK_CITIZEN_REQUEST'
export const UNLINK_CITIZEN_SUCCESS = 'resources/UNLINK_CITIZEN_SUCCESS'
// export const UNLINK_CITIZEN_FAILURE = 'resources/UNLINK_CITIZEN_FAILURE'
export const UNLINK_CITIZEN_ERROR = 'resources/UNLINK_CITIZEN_ERROR'
